import {
  RichTextType,
  Section,
  SectionDetailsType,
  SectionTypes,
} from "../resources/modelTypes";

export type SectionComponentProps = {
  section: Section;
};

export type CollapsedSectionProps = {
  onEditClick: (sectionId: number, sectionType?: SectionTypes) => void;
  section: Section;
};

export type SharedEditSectionProps = {
  details: SectionDetailsType;
  erroredFields: ErrorFields[];
  onSectionDetailsChange: (
    fieldName: string,
    newValue: string | number | boolean | RichTextType | null,
  ) => void;
};

export type SharedEditSectionImageProps = {
  croppedImage?: string | null;
  openMediaManager: () => void;
  photoPk?: number | null;
  onSectionChange: (newData: Partial<Section>) => void;
};

export enum PageSlugs {
  Accommodations = "accommodations",
  Events = "events",
  GuestBook = "guest-book",
  Home = "home",
  Photos = "photos",
  Registry = "registry",
  RSVP = "rsvp",
  WeddingParty = "wedding-party",
  FAQ = "faq",
  Root = "/",
}

export enum ErrorFields {
  Title = "title",
  WebsiteUrl = "websiteUrl",
  AnchorText = "anchorText",
  ButtonText = "buttonText",
  Address1 = "address1",
  City = "city",
  State = "state",
  Venue = "venue",
  Name = "name",
  Question = "question",
  Username = "username",
}
